<template lang="html">
    <div>
        <div class="inner-page" :style="'height:' + pageH + 'px;'">
            <Header>登录</Header>
            <div class="logo-block">
                <img :src="logoUrl" alt="">
<!--                <div class="logo-text">中华传统音乐数字文献图书馆</div>-->
            </div>
            <div class="login-text">
                <div class="inpGroup">
                    <div class="inp-inner">
                        <div class="inp-icons">
                            <van-icon class="icon" class-prefix="iconfont" name="user" />
                            <!-- <span>+86</span> -->
                        </div>
                        <input v-model="uPhone" placeholder="请输入手机号" type="text" maxlength="11">
                    </div>
                </div>
                <div class="inpGroup">
                    <div class="inp-inner">
                        <div class="inp-icons">
                            <van-icon class="icon" class-prefix="iconfont" name="pswd" />
                        </div>
                        <input v-model="uPasscode" type="password" maxlength="18" placeholder="请输入密码">
                    </div>
                </div>
                <div class="subText" @click="push('phonecode')">
                    <!-- <span>忘记密码?</span> -->
                </div>
            </div>
            <div @click="goLogin" :class="['login-btn',{'act':canLogin}]">
                <span v-if="!acRept">登录</span>
                <div v-else class="login-inner">
                    <span>登录中</span>
                    <van-loading class="loading" size="18px" type="spinner" color="#ffffff" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { login } from "@/api/login";
    import logoUrl from '@/assets/logo1.png';
    import vEmits from "@/utils/vEmits";
    import storage from 'good-storage';
    export default {
        data(){
            return{
                logoUrl:logoUrl,
                uPhone: '',
                uPasscode: '',
                acRept: false,
                pageH:''
            }
        },
        computed:{
            canLogin:function(){
                // let phones = /^1[3|4|5|7|8][0-9]{9}$/;
                let phones = /^\S{2,11}$/;
                let passcode = /^[0-9A-z]{6,18}$/;
                let cans = phones.test(this.uPhone) && passcode.test(this.uPasscode);
                return cans;
                // return true;
            }
        },
        methods:{
            ...mapActions('user',[
                'AuserSet'
            ]),

            storeDispatch:function(e){
                this.AuserSet(e);
            },
            goLogin:function(){
                if(this.canLogin && !this.acRept){
                    let vues = this;
                    this.acRept = true;
                    login({
                        account:this.uPhone,
                        pwd:this.uPasscode
                    }).then(res => {
                        // window.console.log(vues.$router.query.account);
                        storage.set('userInfo',{
                            token:res.token,
                            userId:res.id,
                        });
                        vues.storeDispatch(res);
                        vues.$router.go(-1)
                        // if(vues.$router.query.account==''&&vues.$router.query.account==null){
                        //     vues.$router.replace('index');
                        // }

                    }).catch(errs => {
                        vEmits.$emit('show',errs);
                        vues.acRept = false;
                    })
                }else{
                    vEmits.$emit('show','用户名或密码格式错误！');
                }
            }
        },
        created:function(){
            this.pageH = document.documentElement.clientHeight;
        }
    }
</script>

<style lang="css" scoped>
    .inner-page{
        background: white;
    }

    .logo-block{
        text-align: center;
        margin-top: 36px;
    }

    .logo-block img{
        height: 45px;
    }

    .logo-text{
        font-size: 12px;
        letter-spacing: 0.72px;
    }

    /* 输入 */

    .login-text{
        margin-top: 50px;
    }

    .inpGroup{
        margin-top: 18px;
    }

    .inp-inner{
        width: 300px;
        height: 42px;
        margin: 0 auto;
        border: 1px solid #999999;
        border-radius: 3px;
        display: flex;
        align-items: center;
    }

    .inp-icons{
        margin: 0 9px;
        text-align: center;
    }

    .inp-icons .icon{
        font-size: 21px;
        display: inline-block;
        vertical-align: middle;
        color: #af2d2d;
    }

    .inp-icons span{
        display: inline-block;
        vertical-align: middle;
        font-size: 15px;
    }

    .inp-inner input{
        height: 36px;
        border: none;
        width: 210px;
        color: #666666;
        font-size: 14px;
        background: transparent;
    }

    .subText{
        width: 300px;
        margin: 0 auto;
        text-align: right;
        margin-top: 12px;
    }

    .subText span{
        font-size: 14px;
        color: #999999;
    }

    .login-btn{
        width: 300px;
        height: 42px;
        position: relative;
        font-size: 15px;
        letter-spacing: 0.72px;
        line-height: 42px;
        text-align: center;
        background: #999999;
        margin: 0 auto;
        margin-top: 90px;
        color: white;
        border-radius: 3px;
        box-shadow: 0px 3px 6px #999999;
    }

    .login-btn.act{
        background: #af2d2d;
    }

    .loading{
        display: inline-block;
        margin-left: 3px;
    }

</style>
